<template>
  <div class="d-flex justify-content-center">
    <div class="modal-dialog modal-width">
      <div class="modal-content">
        <div class="m-portlet__head modal-changetemplate-title">
          <h3 class="m-portlet__head-text">
            {{ $t("message.ob_change_template_tooltip") }}
          </h3>
        </div>
        <hr class="w-100 mt-0 mb-0" />
        <div>
          <div class="main-template-container">
            <div class="text-left main--item">
              <span class="main--label">
                {{ $t('message.employeePanel.changeTemplate.currentTemplate') }}:
              </span>
              <p class="main--input">{{ templateNameById }}</p>
            </div>
            <div class="text-left main--item">
              <select v-model="newTemplateId" class="main--select mb-3" data-vs-select="new-template">
                <option disabled value="0" data-vs-option-value="add-new-template">
                  {{ $t('message.employeePanel.changeTemplate.newTemplate') }}
                </option>
                <option
                  v-for="(template, i) in reduceTemplateList"
                  :key="template.id"
                  :value="template.id"
                  :data-vs-option-value="`add-new-template-${i}`"
                >{{ template.nombre }}</option
                >
              </select>
            </div>
            <p class="main--message">
              {{ $t('message.employeePanel.changeTemplate.message') }}
            </p>
            <div class="main--footer">
              <button
                type="button"
                @click="closeModal"
                class="btn btn-secondary mr-3 w-100"
                data-vs-button="close-modal-template"
              >
                {{ $t("message.cancel") }}
              </button>
              <button
                @click="changeTemplate"
                class="btn btn-primary w-100"
                data-vs-button="confirm-modal-template"
              >
                {{ $t("message.employee_confirm") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "underscore";
import swal from "sweetalert2";
import Employee from "@/apiClient/Employee";

export default {
  name: "ChangeTemplate",
  props: ["templateId", "setTemplateChanged"],
  data() {
    return {
      newTemplateId: 0
    };
  },
  methods: {
    closeModal() {
      $("#changeTemplate").modal("hide");
    },
    async changeTemplate() {
      const yes_logout_text = this.$t("message.yes_logout_text");
      const not_logout_text = this.$t("message.not_logout_text");

      if (this.newTemplateId !== 0) {
        $("#changeTemplate").modal("toggle");

        const ob = new Employee();

        const { value } = await swal({
          title: this.$t('message.employeePanel.changeTemplate.swal.title'),
          text: this.$t('message.employeePanel.changeTemplate.swal.message'),
          type: "warning",
          showCancelButton: true,
          confirmButtonText: yes_logout_text,
          cancelButtonText: not_logout_text
        });

        if (value) {
          const res = await ob.replaceOnboardingTemplate(
            this.$route.params.id,
            this.newTemplateId
          );
          if (res.status === 200) {
            this.setTemplateChanged(true);
            this.newTemplateId = 0;
            swal({
              title: this.$t("message.employee_edit_success").toString(),
              reverseButtons: false,
              type: "success",
              confirmButtonColor: "#0091b0",
              confirmButtonText: this.$t("message.employee_confirm").toString()
            }).then(() => this.setTemplateChanged(false));
          }
        }
      }
    }
  },
  computed: {
    templateNameById() {
      if (this.templateId) {
        const template = _.find(this.$store.state.onBoardingList, template => {
          return template.id === this.templateId;
        });
        return template.nombre;
      }
    },
    reduceTemplateList() {
      const templateList = _.filter(
        this.$store.state.onBoardingList,
        template => {
          return ((template.id !== this.templateId) && (template.activo === "true"));
        }
      );

      return templateList;
    }
  }
};
</script>
<style lang="scss" scoped>
$primary: #4f41a3;
$textPrimary: #4f4f4f;
$textSecondary: #6f6f6f;
$alertPrimary: #969696;

.modal-changetemplate-title {
  display: flex;
  font-size: 20px !important;
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: normal !important;
  justify-content: flex-start;
  color: $primary;
  padding-right: 200px;
}

.main-template-container {
  padding-left: 46px;
}

.modal-width {
  width: 496px;
}

.main--item {
  padding-top: 20px;
}

.main--label {
  color: $textSecondary;
  font-size: 12px;
  display: block;
  padding-left: 12px;
}

.main--input {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: $textPrimary;
  margin-bottom: 0px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  display: inline-block;
  padding-left: 10px;
  padding-right: 50px;
}

.main--message {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: $alertPrimary;
  padding: 14px 76px 14px 0;
}

.main--btn {
  width: 100%;
  border-radius: 6px;
  text-align: center;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);
}

.main--btn__primary {
  background-color: $primary;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #ffffff;
}

.main--btn__secondary {
  background-color: #ffffff;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: $primary;
  border: 1px solid $primary;
}

.main--footer {
  display: grid;
  grid-template-columns: 184px 184px;
  grid-column-gap: 10px;
  padding-bottom: 24px;
}

.main--select {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding: 8px 50px 8px 10px;
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
  line-height: 24px;
  color: $textPrimary;
}

.main--select option {
  font-style: normal;
  font-weight: normal;
}
</style>
